const NS = 'DashboardNotificationsWidget';
const CLS = 'dashboardNotificationsWidget';

import { DashboardNotificationItemWidget } from '../../dashboardNotificationItemWidget/js/dashboardNotificationItemWidget';
import { VideoModalBlock } from '../../../blocks/videoModalBlock/js/videoModalBlock';

export class DashboardNotificationsWidget {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.api = this.$element.data('api');
		this.notificationReadApi = this.$element.data('notificationReadApi');

		$.ajax({
			type: 'GET',
			url: this.api,
			dataType: 'json',
			success: (response) => {
				let notifications = response;

				if(notifications && notifications.length > 0) {
					this.$element.html(this.getDashboardNotificationsWidgetMarkup(notifications));

					// Instantiate dashboardNotificationItemWidget
					this.$element.find('[data-wg="DashboardNotificationItemWidget"]').each((_index, element) => {
						new DashboardNotificationItemWidget(element);
						new VideoModalBlock($(element).find('[data-blk="VideoModalBlock"]'));
					});
				}
				else {
					this.$element.html(null);
				}
			}
		});
	}

	/**
	 * Iteration of dashboardNotificationItemWidget
	 */
	getDashboardNotificationsWidgetMarkup(notifications) {
		let notificationsMarkup = '';
		notifications.forEach((notification) => {
			notificationsMarkup += this.getDashboardNotificationItemWidgetMarkup(notification);
		});
		return notificationsMarkup;
	}

	/**
	 * Markup is found in dashboardNotificationItemWidget
	 */
	getDashboardNotificationItemWidgetMarkup(notification) {
		return `<div class="dashboardNotificationItemWidget"
			 data-has-video="${!_.isNil(notification.VideoSrcId)}"
			 data-id="${notification.Id}"
			 data-notification-read-api="${this.notificationReadApi}"
			 data-wg="DashboardNotificationItemWidget">
			 ${(() => {
				if(notification.VideoSrcId) {
					return `<div class="dashboardNotificationItemWidget-video">
						${this.getVideoModalBlock(notification.VideoSrcId)}
					</div>`;
				}
				else if(!(_.isNil(notification.Summary) && _.isNil(notification.DatePublished))) {
					return `<div class="dashboardNotificationItemWidget-iconContainer">
						<span class="dashboardNotificationItemWidget-icon icon icon--bell"></span>
					</div>`;
				}
				return '';
			})()}
			<div class="dashboardNotificationItemWidget-message d-flex flex-column justify-content-center">
				${(() => {
					if(notification.Title) {
						return `<div class="dashboardNotificationItemWidget-message-title">
							${notification.Title}
						</div>`;
					}
					return '';
				})()}
				${(() => {
					if(notification.Summary) {
						return `<div class="dashboardNotificationItemWidget-message-description">
							${notification.Summary}
						</div>`;
					}
					return '';
				})()}
			</div>
			<div class="dashboardNotificationItemWidget-floatingHolder">
				${(() => {
					if(notification.DatePublished) {
						return `<div class="dashboardNotificationItemWidget-date d-none d-md-inline-block">${notification.DatePublished}</div>`;
					}
					return '';
				})()}
				<span role="button" aria-label="close" class="dashboardNotificationItemWidget-close icon icon--close"></span>
			</div>
		</div>`;
	}

	/**
	 * Markup is found in videoModalBlock
	 */
	getVideoModalBlock(videoSrcId) {
		return `<div class="videoModalBlock" data-blk="VideoModalBlock" data-video-src-id="${videoSrcId}">
			<div class="videoModalBlock-videoContainer embed-responsive embed-responsive-16by9">
				<div class="videoModalBlock-thumbImage" style="background-image: url('https://img.youtube.com/vi/${videoSrcId}/hqdefault.jpg');"></div>
				<img class="videoModalBlock-playIcon" src="/assets/images/homepageHeroBannerBlock/homepage-play-icon.svg">
			</div>
			<div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="modal" aria-hidden="true">
				<div class="modal-dialog modal-lg">
					<div class="modal-content">
						<div class="modal-header">
							<button type="button" class="close modal-button--close" data-dismiss="modal" aria-label="Close">
								<span class="modal-button--close-text" aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body">
							<div class="videoBlock" data-blk="VideoBlock">
								<div class="embed-responsive embed-responsive-16by9">
									<iframe class="videoBlock-iframe embed-responsive-item"
											src="https://www.youtube.com/embed/${videoSrcId}"></iframe>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>`;
	}
}
